<template>
    <div class="d-flex flex-column align-items-center">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/T3NCz_IVgv4?ecver=1" frameborder="0" allowfullscreen></iframe>
      <p class="mt-2">Zabieg z zastosowaniem urządzenia PlasmaIQ</p>
    </div>
</template>

<script>
export default {
  name: 'section-right',
};
</script>

<styles>
</styles>



// WEBPACK FOOTER //
// SectionRight.vue?3499f84a